<template>
    <div class="spin-wrapper">
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
</template>


<script>

export default {
    name: "LoadSpinner",
    data() {
        return {

        }
    },
    methods: {
        
    }
}

</script>

<style lang="css" scoped>
    @import'./style.css';
</style>
